// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Change Requests Page Styles (Precision SaaS Design System) ──────────────── */

.cr-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.cr-hero-left {
    flex: 1 1;
    min-width: 280px;
}

.cr-badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #fdf2f8;
    color: #db2777;
    border: 1px solid #fbcfe8;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.cr-hero-title {
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 6px 0;
    letter-spacing: -0.5px;
}

.cr-hero-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 12px 0;
    max-width: 620px;
    line-height: 1.5;
}

.cr-meta-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.cr-meta-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
}

.chip-live {
    background: #f0fdf4;
    border-color: #bbf7d0;
    color: #166534;
}

.cr-hero-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.btn-cr-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 18px;
    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
    transition: all 0.2s ease;
}

.btn-cr-primary:hover {
    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%);
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);
    color: #ffffff;
}

/* ── 4 KPI Stat Cards ─────────────────────────────────────────────────── */
.cr-kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.cr-kpi-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 18px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.cr-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.cr-kpi-label {
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.cr-kpi-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.icon-purple { background: #eef2ff; color: #4f46e5; }
.icon-amber { background: #fffbeb; color: #d97706; }
.icon-sky { background: #f0f9ff; color: #0284c7; }
.icon-emerald { background: #ecfdf5; color: #059669; }

.cr-kpi-main {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 10px;
}

.cr-kpi-val {
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.5px;
}

.cr-kpi-tag {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
}

.tag-purple { background: #eef2ff; color: #4f46e5; }
.tag-amber { background: #fffbeb; color: #d97706; }
.tag-sky { background: #f0f9ff; color: #0284c7; }
.tag-emerald { background: #ecfdf5; color: #059669; }

.cr-kpi-progress {
    height: 4px;
    background: #f1f5f9;
    border-radius: 9999px;
    overflow: hidden;
    margin-bottom: 8px;
}

.cr-kpi-progress-bar {
    height: 100%;
    border-radius: 9999px;
}

.bg-purple { background: #4f46e5; }
.bg-amber { background: #d97706; }
.bg-sky { background: #0284c7; }
.bg-emerald { background: #059669; }

.cr-kpi-sub {
    font-size: 11px;
    color: #94a3b8;
}

/* ── Main Directory Card ──────────────────────────────────────────────── */
.cr-main-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    overflow: hidden;
}

.cr-toolbar {
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f1f5f9;
    flex-wrap: wrap;
    gap: 12px;
}

.cr-toolbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.cr-toolbar-title {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.cr-count-badge {
    padding: 2px 8px;
    background: #f1f5f9;
    color: #64748b;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
}

.cr-toolbar-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.cr-filter-tabs {
    display: inline-flex;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 2px;
    gap: 2px;
}

.cr-filter-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    background: transparent;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
}

.cr-filter-btn:hover {
    color: #0f172a;
}

.cr-filter-btn.active {
    background: #ffffff;
    color: #4f46e5;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.cr-filter-count {
    padding: 1px 5px;
    background: #f1f5f9;
    border-radius: 9999px;
    font-size: 10px;
}

.cr-filter-btn.active .cr-filter-count {
    background: #eef2ff;
    color: #4f46e5;
}

.cr-search-box {
    position: relative;
    width: 220px;
}

.cr-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 12px;
}

.cr-search-input {
    width: 100%;
    padding: 6px 28px 6px 30px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 12px;
    outline: none;
    transition: border-color 0.2s ease;
}

.cr-search-input:focus {
    border-color: #4f46e5;
}

.cr-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 0;
}

/* ── Custom Table Styles ──────────────────────────────────────────────── */
.table-cr-custom {
    width: 100%;
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
}

.table-cr-custom thead th {
    background: #f8fafc;
    padding: 12px 16px;
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
}

.table-cr-custom tbody tr {
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.table-cr-custom tbody tr:hover {
    background-color: #f8fafc;
}

.table-cr-custom tbody td {
    padding: 12px 16px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 12px;
    vertical-align: middle;
}

.cr-col-idx {
    font-weight: 700;
    color: #94a3b8;
    width: 40px;
    text-align: center;
}

.cr-title-cell {
    display: flex;
    align-items: center;
    gap: 10px;
}

.cr-icon-avatar {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #fdf2f8;
    color: #db2777;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.cr-title-text {
    font-weight: 700;
    color: #0f172a;
    font-size: 13px;
}

.cr-sub-text {
    font-size: 11px;
    color: #94a3b8;
}

.cr-project-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    background: #f1f5f9;
    color: #475569;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
}

.cr-prio-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
}

.prio-urgent { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }
.prio-high { background: #fff7ed; color: #ea580c; border: 1px solid #ffedd5; }
.prio-medium { background: #fffbeb; color: #d97706; border: 1px solid #fef3c7; }
.prio-low { background: #f0fdf4; color: #16a34a; border: 1px solid #dcfce7; }

.cr-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
}

.status-submitted { background: #e0f2fe; color: #0284c7; }
.status-inreview { background: #fef3c7; color: #b45309; }
.status-approved { background: #ede9fe; color: #6d28d9; }
.status-inprogress { background: #dbeafe; color: #1d4ed8; }
.status-completed { background: #dcfce7; color: #15803d; }
.status-rejected { background: #fee2e2; color: #b91c1c; }

.cr-hours-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    color: #334155;
}

.cr-date-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #64748b;
    font-size: 12px;
}

.btn-cr-view {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    color: #334155;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-cr-view:hover {
    background: #eef2ff;
    color: #4f46e5;
    border-color: #c7d2fe;
}

.btn-cr-delete {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    background: #fef2f2;
    border: 1px solid #fee2e2;
    border-radius: 6px;
    color: #dc2626;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-cr-delete:hover {
    background: #fee2e2;
}

/* ── Modal Details ────────────────────────────────────────────────────── */
.cr-modal-custom .modal-content {
    border-radius: 14px;
    border: none;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.cr-modal-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.cr-modal-title {
    font-size: 16px;
    font-weight: 800;
    color: #0f172a;
    margin: 0;
}

.cr-modal-subtitle {
    font-size: 12px;
    color: #64748b;
}

.cr-input {
    border-radius: 8px;
    border: 1px solid #cbd5e1;
}

.cr-input:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.cr-status-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
}

.banner-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.banner-label {
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
}

.banner-hours {
    font-size: 12px;
    color: #334155;
}

.cr-detail-section {
    margin-bottom: 18px;
}

.section-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #64748b;
    margin-bottom: 6px;
}

.section-content {
    font-size: 13px;
    color: #334155;
    line-height: 1.6;
}

.admin-notes-box {
    background: #f5f3ff;
    border: 1px solid #ddd6fe;
    border-radius: 8px;
    padding: 14px;
}

.text-indigo { color: #6d28d9; }

.reviewed-by-tag {
    font-size: 11px;
    color: #6b7280;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #ede9fe;
}

.cr-attachments-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
}

.cr-attachment-card {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    text-decoration: none;
    color: inherit;
    transition: all 0.2s ease;
}

.cr-attachment-card:hover {
    border-color: #4f46e5;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.1);
}

.attachment-icon {
    font-size: 20px;
    color: #4f46e5;
}

.attachment-info .file-name {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.attachment-info .file-meta {
    display: block;
    font-size: 10px;
    color: #94a3b8;
}

.spin-icon {
    animation: spin 2s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.cr-loading-wrap {
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
}

.cr-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e2e8f0;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto 12px auto;
}

.cr-empty-state {
    padding: 60px 20px;
    text-align: center;
}

.cr-empty-icon-wrap {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin: 0 auto 16px auto;
}

.cr-empty-title {
    font-size: 16px;
    font-weight: 800;
    color: #0f172a;
    margin-bottom: 6px;
}

.cr-empty-desc {
    font-size: 13px;
    color: #94a3b8;
    max-width: 420px;
    margin: 0 auto 20px auto;
}

/* ── Modern File Upload Dropzone & Multiple Files List ───────────────── */
.cr-dropzone {
    border: 2px dashed #cbd5e1;
    border-radius: 10px;
    padding: 22px 16px;
    text-align: center;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    -webkit-user-select: none;
            user-select: none;
}

.cr-dropzone:hover {
    border-color: #6366f1;
    background: #f5f7ff;
}

.cr-dropzone.dragging {
    border-color: #4f46e5;
    background: #eef2ff;
    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.12);
}

.cr-dropzone-icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin: 0 auto 10px auto;
    transition: transform 0.2s ease, background 0.2s ease;
}

.cr-dropzone:hover .cr-dropzone-icon {
    transform: translateY(-2px);
    background: #e0e7ff;
}

.cr-dropzone-title {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
}

.cr-browse-link {
    color: #4f46e5;
    text-decoration: underline;
    font-weight: 700;
}

.cr-dropzone-subtitle {
    font-size: 11.5px;
    color: #64748b;
}

/* ── Selected File Chips / List ── */
.cr-selected-files-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    max-height: 180px;
    overflow-y: auto;
    padding-right: 4px;
}

.cr-file-chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.15s ease;
}

.cr-file-chip:hover {
    border-color: #cbd5e1;
    background: #fafafa;
}

.cr-file-chip-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1 1;
}

.cr-chip-icon {
    font-size: 20px;
    flex-shrink: 0;
}

.cr-chip-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.cr-chip-name {
    font-size: 12.5px;
    font-weight: 600;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 380px;
}

.cr-chip-size {
    font-size: 10.5px;
    color: #64748b;
}

.cr-chip-remove-btn {
    background: transparent;
    border: none;
    color: #94a3b8;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
    margin-left: 8px;
}

.cr-chip-remove-btn:hover {
    background: #fee2e2;
    color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChangeRequests.css"],"names":[],"mappings":"AAAA,mFAAmF;;AAEnF;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,6DAA6D;IAC7D,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,8CAA8C;IAC9C,cAAc;AAClB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,YAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,WAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA,aAAa,mBAAmB,EAAE;AAClC,YAAY,mBAAmB,EAAE;AACjC,UAAU,mBAAmB,EAAE;AAC/B,cAAc,mBAAmB,EAAE;;AAEnC;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,4EAA4E;AAC5E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA,4EAA4E;AAC5E;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,aAAa,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC7E,eAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/E,YAAY,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE5E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4EAA4E;AAC5E;IACI,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,eAAe,cAAc,EAAE;;AAE/B;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,2EAA2E;AAC3E;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iDAAiD;IACjD,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":["/* ── Change Requests Page Styles (Precision SaaS Design System) ──────────────── */\n\n.cr-hero-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.cr-hero-left {\n    flex: 1;\n    min-width: 280px;\n}\n\n.cr-badge-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #fdf2f8;\n    color: #db2777;\n    border: 1px solid #fbcfe8;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\n.cr-hero-title {\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0 0 6px 0;\n    letter-spacing: -0.5px;\n}\n\n.cr-hero-subtitle {\n    font-size: 13px;\n    color: #64748b;\n    margin: 0 0 12px 0;\n    max-width: 620px;\n    line-height: 1.5;\n}\n\n.cr-meta-chips {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.cr-meta-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n}\n\n.chip-live {\n    background: #f0fdf4;\n    border-color: #bbf7d0;\n    color: #166534;\n}\n\n.cr-hero-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.btn-cr-primary {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 9px 18px;\n    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n    color: #ffffff;\n    border: none;\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);\n    transition: all 0.2s ease;\n}\n\n.btn-cr-primary:hover {\n    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);\n    color: #ffffff;\n}\n\n/* ── 4 KPI Stat Cards ─────────────────────────────────────────────────── */\n.cr-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.cr-kpi-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 18px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.cr-kpi-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.cr-kpi-label {\n    font-size: 12px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.cr-kpi-icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.icon-purple { background: #eef2ff; color: #4f46e5; }\n.icon-amber { background: #fffbeb; color: #d97706; }\n.icon-sky { background: #f0f9ff; color: #0284c7; }\n.icon-emerald { background: #ecfdf5; color: #059669; }\n\n.cr-kpi-main {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.cr-kpi-val {\n    font-size: 26px;\n    font-weight: 800;\n    letter-spacing: -0.5px;\n}\n\n.cr-kpi-tag {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 4px;\n}\n\n.tag-purple { background: #eef2ff; color: #4f46e5; }\n.tag-amber { background: #fffbeb; color: #d97706; }\n.tag-sky { background: #f0f9ff; color: #0284c7; }\n.tag-emerald { background: #ecfdf5; color: #059669; }\n\n.cr-kpi-progress {\n    height: 4px;\n    background: #f1f5f9;\n    border-radius: 9999px;\n    overflow: hidden;\n    margin-bottom: 8px;\n}\n\n.cr-kpi-progress-bar {\n    height: 100%;\n    border-radius: 9999px;\n}\n\n.bg-purple { background: #4f46e5; }\n.bg-amber { background: #d97706; }\n.bg-sky { background: #0284c7; }\n.bg-emerald { background: #059669; }\n\n.cr-kpi-sub {\n    font-size: 11px;\n    color: #94a3b8;\n}\n\n/* ── Main Directory Card ──────────────────────────────────────────────── */\n.cr-main-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n}\n\n.cr-toolbar {\n    padding: 16px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #f1f5f9;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.cr-toolbar-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.cr-toolbar-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n}\n\n.cr-count-badge {\n    padding: 2px 8px;\n    background: #f1f5f9;\n    color: #64748b;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.cr-toolbar-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.cr-filter-tabs {\n    display: inline-flex;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 2px;\n    gap: 2px;\n}\n\n.cr-filter-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 5px 10px;\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.cr-filter-btn:hover {\n    color: #0f172a;\n}\n\n.cr-filter-btn.active {\n    background: #ffffff;\n    color: #4f46e5;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.cr-filter-count {\n    padding: 1px 5px;\n    background: #f1f5f9;\n    border-radius: 9999px;\n    font-size: 10px;\n}\n\n.cr-filter-btn.active .cr-filter-count {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n.cr-search-box {\n    position: relative;\n    width: 220px;\n}\n\n.cr-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n    font-size: 12px;\n}\n\n.cr-search-input {\n    width: 100%;\n    padding: 6px 28px 6px 30px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 12px;\n    outline: none;\n    transition: border-color 0.2s ease;\n}\n\n.cr-search-input:focus {\n    border-color: #4f46e5;\n}\n\n.cr-search-clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* ── Custom Table Styles ──────────────────────────────────────────────── */\n.table-cr-custom {\n    width: 100%;\n    margin-bottom: 0;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.table-cr-custom thead th {\n    background: #f8fafc;\n    padding: 12px 16px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.table-cr-custom tbody tr {\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n}\n\n.table-cr-custom tbody tr:hover {\n    background-color: #f8fafc;\n}\n\n.table-cr-custom tbody td {\n    padding: 12px 16px;\n    border-bottom: 1px solid #f1f5f9;\n    font-size: 12px;\n    vertical-align: middle;\n}\n\n.cr-col-idx {\n    font-weight: 700;\n    color: #94a3b8;\n    width: 40px;\n    text-align: center;\n}\n\n.cr-title-cell {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.cr-icon-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    background: #fdf2f8;\n    color: #db2777;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n}\n\n.cr-title-text {\n    font-weight: 700;\n    color: #0f172a;\n    font-size: 13px;\n}\n\n.cr-sub-text {\n    font-size: 11px;\n    color: #94a3b8;\n}\n\n.cr-project-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 8px;\n    background: #f1f5f9;\n    color: #475569;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.cr-prio-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 8px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.prio-urgent { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }\n.prio-high { background: #fff7ed; color: #ea580c; border: 1px solid #ffedd5; }\n.prio-medium { background: #fffbeb; color: #d97706; border: 1px solid #fef3c7; }\n.prio-low { background: #f0fdf4; color: #16a34a; border: 1px solid #dcfce7; }\n\n.cr-status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.status-submitted { background: #e0f2fe; color: #0284c7; }\n.status-inreview { background: #fef3c7; color: #b45309; }\n.status-approved { background: #ede9fe; color: #6d28d9; }\n.status-inprogress { background: #dbeafe; color: #1d4ed8; }\n.status-completed { background: #dcfce7; color: #15803d; }\n.status-rejected { background: #fee2e2; color: #b91c1c; }\n\n.cr-hours-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 8px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #334155;\n}\n\n.cr-date-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: #64748b;\n    font-size: 12px;\n}\n\n.btn-cr-view {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 10px;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    color: #334155;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-cr-view:hover {\n    background: #eef2ff;\n    color: #4f46e5;\n    border-color: #c7d2fe;\n}\n\n.btn-cr-delete {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 8px;\n    background: #fef2f2;\n    border: 1px solid #fee2e2;\n    border-radius: 6px;\n    color: #dc2626;\n    font-size: 11px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-cr-delete:hover {\n    background: #fee2e2;\n}\n\n/* ── Modal Details ────────────────────────────────────────────────────── */\n.cr-modal-custom .modal-content {\n    border-radius: 14px;\n    border: none;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.cr-modal-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n}\n\n.cr-modal-title {\n    font-size: 16px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0;\n}\n\n.cr-modal-subtitle {\n    font-size: 12px;\n    color: #64748b;\n}\n\n.cr-input {\n    border-radius: 8px;\n    border: 1px solid #cbd5e1;\n}\n\n.cr-input:focus {\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.cr-status-banner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.banner-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.banner-label {\n    font-size: 12px;\n    font-weight: 700;\n    color: #64748b;\n}\n\n.banner-hours {\n    font-size: 12px;\n    color: #334155;\n}\n\n.cr-detail-section {\n    margin-bottom: 18px;\n}\n\n.section-title {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #64748b;\n    margin-bottom: 6px;\n}\n\n.section-content {\n    font-size: 13px;\n    color: #334155;\n    line-height: 1.6;\n}\n\n.admin-notes-box {\n    background: #f5f3ff;\n    border: 1px solid #ddd6fe;\n    border-radius: 8px;\n    padding: 14px;\n}\n\n.text-indigo { color: #6d28d9; }\n\n.reviewed-by-tag {\n    font-size: 11px;\n    color: #6b7280;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid #ede9fe;\n}\n\n.cr-attachments-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 10px;\n}\n\n.cr-attachment-card {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    text-decoration: none;\n    color: inherit;\n    transition: all 0.2s ease;\n}\n\n.cr-attachment-card:hover {\n    border-color: #4f46e5;\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.1);\n}\n\n.attachment-icon {\n    font-size: 20px;\n    color: #4f46e5;\n}\n\n.attachment-info .file-name {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: #0f172a;\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.attachment-info .file-meta {\n    display: block;\n    font-size: 10px;\n    color: #94a3b8;\n}\n\n.spin-icon {\n    animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n.cr-loading-wrap {\n    padding: 60px 20px;\n    text-align: center;\n    color: #64748b;\n}\n\n.cr-spinner {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #e2e8f0;\n    border-top-color: #4f46e5;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin: 0 auto 12px auto;\n}\n\n.cr-empty-state {\n    padding: 60px 20px;\n    text-align: center;\n}\n\n.cr-empty-icon-wrap {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: #f1f5f9;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    margin: 0 auto 16px auto;\n}\n\n.cr-empty-title {\n    font-size: 16px;\n    font-weight: 800;\n    color: #0f172a;\n    margin-bottom: 6px;\n}\n\n.cr-empty-desc {\n    font-size: 13px;\n    color: #94a3b8;\n    max-width: 420px;\n    margin: 0 auto 20px auto;\n}\n\n/* ── Modern File Upload Dropzone & Multiple Files List ───────────────── */\n.cr-dropzone {\n    border: 2px dashed #cbd5e1;\n    border-radius: 10px;\n    padding: 22px 16px;\n    text-align: center;\n    background: #f8fafc;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    user-select: none;\n}\n\n.cr-dropzone:hover {\n    border-color: #6366f1;\n    background: #f5f7ff;\n}\n\n.cr-dropzone.dragging {\n    border-color: #4f46e5;\n    background: #eef2ff;\n    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.12);\n}\n\n.cr-dropzone-icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    margin: 0 auto 10px auto;\n    transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.cr-dropzone:hover .cr-dropzone-icon {\n    transform: translateY(-2px);\n    background: #e0e7ff;\n}\n\n.cr-dropzone-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 4px;\n}\n\n.cr-browse-link {\n    color: #4f46e5;\n    text-decoration: underline;\n    font-weight: 700;\n}\n\n.cr-dropzone-subtitle {\n    font-size: 11.5px;\n    color: #64748b;\n}\n\n/* ── Selected File Chips / List ── */\n.cr-selected-files-list {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    max-height: 180px;\n    overflow-y: auto;\n    padding-right: 4px;\n}\n\n.cr-file-chip {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n    transition: all 0.15s ease;\n}\n\n.cr-file-chip:hover {\n    border-color: #cbd5e1;\n    background: #fafafa;\n}\n\n.cr-file-chip-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n    flex: 1;\n}\n\n.cr-chip-icon {\n    font-size: 20px;\n    flex-shrink: 0;\n}\n\n.cr-chip-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.cr-chip-name {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: #0f172a;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 380px;\n}\n\n.cr-chip-size {\n    font-size: 10.5px;\n    color: #64748b;\n}\n\n.cr-chip-remove-btn {\n    background: transparent;\n    border: none;\n    color: #94a3b8;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n    margin-left: 8px;\n}\n\n.cr-chip-remove-btn:hover {\n    background: #fee2e2;\n    color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
